import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WorldService {
    worldTimeScale = 1;
    spawnNpcRequest$ = new Subject<void>();
    spawnCopRequest$ = new Subject<void>();
    restartGameRequest$ = new Subject<void>();
    navmeshDebugRequest$ = new Subject<boolean>();
    collisionDebugRequest$ = new Subject<boolean>();
    ragdollDebugRequest$ = new Subject<boolean>();
    navmeshDebugEnabled = false;
    collisionDebugEnabled = false;
    ragdollDebugEnabled = false;
    greyBoxModeEnabled = false;

    readonly ragdollBoneNames: readonly string[] = [
        'Hips',
        'Spine', 'Spine1', 'Spine2',
        'Neck', 'Head',
        'ShoulderLeft', 'ArmLeft', 'ForeArmLeft', 'HandLeft',
        'ShoulderRight', 'ArmRight', 'ForeArmRight', 'HandRight',
        'UpLegLeft', 'LegLeft', 'FootLeft',
        'UpLegRight', 'LegRight', 'FootRight',
    ];

    readonly ragdollDisabledBones: Set<string> = new Set();

    setWorldTimeScale(value: number): void {
        this.worldTimeScale = value;
    }

    spawnNpc(): void {
        this.spawnNpcRequest$.next();
    }

    spawnCop(): void {
        this.spawnCopRequest$.next();
    }

    restartGame(): void {
        this.restartGameRequest$.next();
    }

    toggleNavmeshDebug(): void {
        this.navmeshDebugEnabled = !this.navmeshDebugEnabled;
        this.navmeshDebugRequest$.next(this.navmeshDebugEnabled);
    }

    toggleCollisionDebug(): void {
        this.collisionDebugEnabled = !this.collisionDebugEnabled;
        this.collisionDebugRequest$.next(this.collisionDebugEnabled);
    }

    toggleRagdollDebug(): void {
        this.ragdollDebugEnabled = !this.ragdollDebugEnabled;
        this.ragdollDebugRequest$.next(this.ragdollDebugEnabled);
    }

    isBoneEnabled(boneName: string): boolean {
        return !this.ragdollDisabledBones.has(boneName);
    }

    toggleRagdollBone(boneName: string): void {
        if (this.ragdollDisabledBones.has(boneName)) {
            this.ragdollDisabledBones.delete(boneName);
        } else {
            this.ragdollDisabledBones.add(boneName);
        }
    }
}
